<div class="container-modal">
	<div class="container">
		<div class="container-modal-body container-modal-body-help p-5">
			<div class="row justify-content-end h-50">
				<div class="col col-sm-6 col-md-7 col-lg-5 bg-primary rounded container-content">
					<p class="fs-4 fw-bold">{{ 'callUs.help' | translate }}</p>
					<p class="fs-6 mb-1">{{ 'callUs.phoneToCall' | translate }}</p>
					<p class="fs-6 fw-medium">+34 910 008 715</p>
					<p class="fs-6 fw-medium" *ngIf="submotiveShown !== ''">
						{{ submotiveShown }}
					</p>
				</div>
			</div>
		</div>
	</div>
</div>
